var render, staticRenderFns
import script from "./AxButton.vue?vue&type=script&lang=ts&"
export * from "./AxButton.vue?vue&type=script&lang=ts&"
import style0 from "./AxButton.vue?vue&type=style&index=0&id=74da7c9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da7c9f",
  null
  
)

export default component.exports